import React, { useState, useEffect } from 'react';
import { useStore } from 'hooks';
import Menu from 'components/menu';
import Table from 'components/table';
import moment from 'moment';
import { EVENT_TYPE, ROLE } from 'helpers/constants';
import { Filter } from 'components/applications';
import { EventLogsService } from 'services';
import styles from './logs.module.scss';

const EVENT_TYPE_OPTIONS = Object.values(EVENT_TYPE)
  .filter(v => typeof v === 'number')
  .map(n => ({ number: n, string: EVENT_TYPE.toString(n) }));

const LOGS_FILTERS = {
  eventType: {
    type: 'select',
    field: 'eventType',
    label: 'Тип события',
    values: EVENT_TYPE_OPTIONS.map(({ number, string }) => ({ id: String(number), value: string })),
    emptyValue: false,
  },
};

const mapLogToRow = (el) => ({
  ...el,
  name: el.user?.name,
  role: el.user?.role ? ROLE.toString(el.user.role.code) : '',
  createdAt: moment(el.createdAt).format('YYYY-MM-DD HH:mm'),
  email: el.user?.email,
  requestId: el.applicationWagonId || el.applicationSupplyId || null,
});

const Logs = () => {
  const { setUser, setLoading } = useStore();
  const [query, setQuery] = useState({ eventType: 0 });
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [count, setCount] = useState(0);
  const [logs, setLogs] = useState([]);

  const setQueryAndResetPage = (upd) => {
    setQuery(prev => ({ ...prev, ...upd }));
    setPage(0);
  };

  useEffect(() => {
    let cancelled = false;

    async function fetchLogs() {
      setLoading(true);
      const response = await new EventLogsService({ setUser }).getEventLogs({
        eventType: Number(query.eventType ?? 0),
        page,
        limit,
      });
      setLoading(false);

      if (cancelled || !response) return;
      if (response.items != null) {
        setLogs(response.items.map(mapLogToRow));
        setCount(response.count ?? 0);
      }
    }

    fetchLogs();
    return () => { cancelled = true; };
  }, [query.eventType, page, limit, setLoading, setUser]);

  const [cells] = useState([
    [
      {
        name: 'Имя Пользователя',
        renderField: 'name',
      },
      {
        name: 'Роль Пользователя',
        renderField: 'role',
      },
      {
        name: 'Время посещения',
        renderField: 'createdAt',
      },
    ],
    [
      {
        name: 'Имя Пользователя',
        renderField: 'name',
      },
      {
        name: 'Роль Пользователя',
        renderField: 'role',
      },
      {
        name: 'Дата создания',
        renderField: 'createdAt',
      },
      {
        name: 'Дата отправки письма',
        renderField: 'createdAt',
      },
      {
        name: 'Email получателя',
        renderField: 'email',
      }],
    [
      {
        name: 'ID Заявки',
        renderField: 'requestId',
      },
      {
        name: 'Изменено пользователем:',
        renderField: 'name',
      },
      {
        name: 'Время',
        renderField: 'createdAt',
      },
      {
        name: 'Комментарий',
        renderField: 'comment',
      }],
    [
      {
        renderField: 'requestId',
        name: 'ID Заявки',
      },
      {
        renderField: 'deliveryDate',
        name: 'Дата доставки',
      },
    ],
    [
      {
        name: 'Пользователь',
        renderField: 'name',
      },
      {
        name: 'Время',
        renderField: 'createdAt',
      },
      {
        renderField: 'comment',
        name: 'Комментарий',
      },
    ],
    [
      {
        name: 'Пользователь',
        renderField: 'name',
      },
      {
        name: 'Время',
        renderField: 'createdAt',
      },
      {
        renderField: 'comment',
        name: 'Комментарий',
      },
    ],
    [
      {
        name: 'Пользователь',
        renderField: 'name',
      },
      {
        name: 'Время',
        renderField: 'createdAt',
      },
      {
        renderField: 'comment',
        name: 'Комментарий',
      },
    ],
  ]);

  const eventTypeIndex = Number(query.eventType ?? 0);

  return (
    <>
      <div className={styles.menu}>
        <Menu
          rightFilter={(
            <Filter
              hideMenu
              filters={LOGS_FILTERS}
              query={query}
              setQuery={setQueryAndResetPage}
              showFilter
            />
          )}
        />
      </div>
      <div className={styles.table}>
        <Table
          cells={cells[eventTypeIndex] || cells[4]}
          data={logs}
          count={count}
          page={page}
          limit={limit}
          onPageChange={({ selected }) => setPage(selected)}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            setPage(0);
          }}
        />
      </div>
    </>
  );
};

export default Logs;
